import type { FaireProductEntity } from "../../entity_types/product";

export const p_5aaukhs8sh: FaireProductEntity = {
  token: "p_5aaukhs8sh",
  type: "product",
  name: "Christmas Tree Stacking Toy, Baby & Toddlers Montessori Gift",
  brandToken: "b_56m6aez3hh",
  brandName: "Pearhead",
  imageUrl: "https://cdn.faire.com/fastly/4d4ad45651a5907d172dd98c431cfeb5785e44a5dd09375969ecb9f36472f49a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c4741d30ff63d0cafc754df2fd19d76e3a53b44b8a19b36ae9aa2fa00c4e0382.jpeg",
    "https://cdn.faire.com/fastly/e19f68d8afd13597c3e21c4774d2fd2116e03fd37107ffba97b2402aac139e94.jpeg",
    "https://cdn.faire.com/fastly/0eb164c71df65da4d21a236d16840bfab1438afd5849454a40718fe401c574a2.jpeg",
    "https://cdn.faire.com/fastly/6be6d5706925a3a871102236e3e98554cadaaa398b9d8910116e42763c74cc7a.jpeg",
    "https://cdn.faire.com/fastly/4f3a19eacc53e8a7247127b1e77f6fc40c30e36446ed0660cd521476e0f0dd22.jpeg",
    "https://cdn.faire.com/fastly/92205b43442d8ab20f9efa34f49b487a0699caf41e207cd46c6bb35a741f673e.jpeg",
    "https://cdn.faire.com/fastly/1f66b36358f02f1e172c47cea518f29219755cc994f46c65f3149ab27c47507d.jpeg",
    "https://cdn.faire.com/fastly/1344cdd4a33cf5cc26c1369d0f641b9d2b82a40665cdcdcf191dadb27967472c.jpeg",
    "https://cdn.faire.com/fastly/5ce1c8a108456b59f82336fde857570955b6f1bf30afe9ee0aa66d53b1ac90a3.jpeg"
  ],
  priceDollars: 7.5,
  description: "• Holiday Playtime Fun: Delight your baby girl or baby boy with Pearhead’s Christmas tree stacking toy. Encourages interactive play, fine motor skill development, and imaginative holiday fun for little ones 12 months and up.\n• Festive Design: Includes a red base, 5 green and white stacking rings, and a golden star topper, perfect for seasonal play or decorating a nursery with cheerful Christmas charm.\n• Create Lasting Memories: This fun holiday toy provides quality bonding time between parents and baby, capturing joyful moments that will be cherished for years to come.\n• Perfect Holiday Gift: Ideal Christmas gift, holiday gift, baby shower gift, toddler toy, newborn gift, gender-neutral baby toy, or festive nursery décor addition for boys and girls.\n• Compact & Safe Size: Measures 4”W x 5.7”H x 4”D; durable, toddler-safe materials make it perfect for stacking, exploring, and adding holiday charm to any nursery or playroom.",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:58.111Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
